enum events {
  EDIT_TEMPLATE = 'edit-email-template',
  EDIT_CLOSE = 'edit-email-template-closed',
}

export default events